<template lang="pug">
  .transactions
    .background-header.white
      v-container.pb-0.white(style="max-width: 600px")
        div.my-2.d-flex.align-center
          v-icon(left color="black" :size="24" @click="$router.push('/admin/restaurant/pos-setup')") mdi-arrow-left
          v-text-field.mx-2(v-model="searchFilters.keyword" hide-details dense outlined height="40" background-color="basic200" :placeholder="$t('search_transactions')")
            template(v-slot:append)
              eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
          v-btn.elevation-0.pa-0(color="transparent" small icon @click="openFilterSheet")
            eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="23" style="margin-top: 2px")
    //- v-container.white.py-2(style="max-width: 600px")
      div.d-flex
        v-spacer
        v-btn.label.pa-0.px-4(color="primary400" text @click="exportCsv()")
          eva-icon.mt-1.mr-1(name="external-link-outline" :fill=" $vuetify.theme.themes[$theme].primary400" width="14")
          | export
        v-btn.label.pl-0.pr-2(color="primary400" text @click="openFilterSheet()")
          eva-icon.mt-1.mr-1(name="options-2-outline" :fill=" $vuetify.theme.themes[$theme].primary400" width="14")
          | filter

    v-container.py-2.px-0(v-if="searchFilters.gateway || searchFilters.createdDate.length > 0" :style="`max-width: 600px; background-color: ${$vuetify.theme.themes[$theme].basic600T08} !important`")
      div.d-flex
        span.ml-1
        v-chip.mx-1(v-if="searchFilters.gateway" color="basic600" close outlined close-icon="mdi-close" small @click:close="searchFilters.gateway = ''") {{ searchFilters.gateway }}
        v-chip.mx-1(v-if="searchFilters.createdDate.length > 0" color="basic600" close outlined close-icon="mdi-close" small @click:close="searchFilters.createdDate = []")
          template(v-if="searchFilters.createdDate.length > 1") {{ searchFilters.createdDate[0] | humanizeDate }} ~ {{ searchFilters.createdDate[1] | humanizeDate }}
          template(v-else) {{ searchFilters.createdDate[0] | humanizeDate }}  
    v-container.pa-0(style="max-width: 600px")
      v-layout.my-6(v-if="transactions.length == 0" v-show="!isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          div.mx-auto
            v-img.mx-auto(contain style="width:80px; height:80px"
                          :src="require('@/assets/images/icon_empty.png')")
            p.caption {{ $t('no_transaction_found') }}

      template(v-for="(transaction, index) in transactions")
        transaction-item.list-item(:key="transaction.uid" :transaction="transaction" :index="index")

      y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(indeterminate color="primary" :width="2" :size="50")

    .modals
      y-bottom-sheet(v-model="showFilterSheet" inset scrollable max-width="600px")
        v-card
          v-card-title.px-4
            div.h6.basic800--text {{ $t('filter_transactions') }}
            v-spacer
            v-btn(color="white" text @click="clearFilter()")
              .button-Aa-small.primary400--text {{ $t('clear_filters') }}
            v-btn.px-4(color="textColorAccent" depressed height=32 dark @click="filterData()")
              .button-AA-small.basic100--text {{ $t('filter') }}
          v-divider.basic300
          v-card-text.px-4.pb-8
            //- div.mt-4
              p.mb-0.label.basic600--text {{ $t('payment_method') }}
              v-select.mt-2(item-color="basic100" v-model="filter.gateway" :items="gatewaySelections" item-text="name" item-value="id" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down")
            div.mt-4
              p.mb-0.label.basic600--text {{ $t('date') }}
              v-dialog(v-model="datePickerOpen" max-width="320px")
                template(v-slot:activator="{ on, attrs }")
                  v-text-field.mt-2(v-model="dateRangeText" dense solo flat outlined background-color="basic200" v-bind="attrs" v-on="on" append-icon="mdi-chevron-down" hide-details readonly type="button" style="text-align-last: left")
                v-date-picker(v-model="filter.createdDate" range no-title)
                  v-spacer
                  v-btn(color="white" text @click="pickDatesCancel()")
                    .button-Aa-small.primary400--text {{ $t('cancel') }}
                  v-btn.mr-2(color="textColorAccent" depressed height=32 dark @click="pickDates")
                    .button-AA-small.basic100--text OK
</template>

<script>
import queryString from 'query-string'
import { mapState } from 'vuex'
import TransactionItem from '@/components/restaurant/TransactionItem.vue'

export default {
  name: 'Transactions',
  components: { TransactionItem },
  props: ['company'],
  data () {
    return {
      menu: false,
      transactions: [],
      isFetching: false,
      page: 1,
      pageSize: 10,
      count: 0,
      filter: {
        createdDate:[],
        gateway: ''
      },
      datePickerOpen: false,
      searchFilters: {
        createdDate:[],
        gateway: '',
        keyword: '',
      },
      searchCountDown: null,
      gatewaySelections: [
        {name: 'All', id: ''},
        {name: 'Yezzapay', id: 'yezzapay'},
        {name: 'Direct bank transfer', id: 'direct'},
        {name: 'Billplz',id: 'billplz'},
        {name: 'MOLPay', id: 'molpay'},
        {name: '2c2p', id: 'twoctwop'}
      ],
      showFilterSheet: false,
    }
  },
  computed: {
    ...mapState('user', ['user', 'member']),
    dateRangeText () {
      // Return date range as readable text
      if (this.filter.createdDate.length == 2) {
        return `${this.$options.filters.humanizeDate(this.filter.createdDate[0])} ~ ${this.$options.filters.humanizeDate(this.filter.createdDate[1])}`
      } else if (this.filter.createdDate.length == 1) {
        return this.$options.filters.humanizeDate(this.filter.createdDate[0])
      } else{
        return 'All dates'
      }
    },
    filterParams () {
      // Create GET params for querying transaction list
      let params = {
        ordering: '-created',
        company: this.company.id,
        page: this.page,
        page_size: this.pageSize,
        gateway: this.searchFilters.gateway,
      }

      // Assign date
      if(this.searchFilters.createdDate.length == 2){
        params.created_after = this.searchFilters.createdDate[0]
        params.created_before = this.searchFilters.createdDate[1]
      }else if(this.searchFilters.createdDate.length == 1){
        params.created_after = this.searchFilters.createdDate[0]
        params.created_before = this.searchFilters.createdDate[0]
      }

      // Search mode: lead.rid and free keyword
      if (this.searchFilters.keyword && this.searchFilters.keyword.length >= 2) {
        if(this.searchFilters.keyword.startsWith('#')) {
          params.rid = this.searchFilters.keyword.replace('#', '')
        }else{
          params.search = this.searchFilters.keyword
        }
      }
      return params
    }
  },
  mounted () {
    if(this.$route.query.page) this.page = parseInt(this.$route.query.page)
    this.fetchTransactions()
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchTransactions()
      }
    },
    searchFilters: {
      handler (val) {
        // Swap date order if inverted
        if(val.createdDate.length == 2 && val.createdDate[0] > val.createdDate[1]) {
          val.createdDate = [val.createdDate[1], val.createdDate[0]]
        }
        // Refetch transactions based on current filter
        if (this.searchCountDown) {
          clearTimeout(this.searchCountDown)
        }
        this.searchCountDown = setTimeout(() => {
          this.transactions = []
          this.page = 1
          this.fetchTransactions()
        }, 500)
      },
      deep: true
    }
  },
  methods: {
    fetchTransactions () {
      this.isFetching = true
      let url = `/transactions`
      this.$axios.get(url, { params: this.filterParams }).then((response) => {
        this.isFetching = false
        this.transactions = response.data.results
        this.count = response.data.count
      }).catch(() => {})
    },
    openFilterSheet () {
      this.filter.createdDate = this.searchFilters.createdDate
      this.filter.gateway = this.searchFilters.gateway
      this.showFilterSheet = true
    },
    filterData () {
      this.showFilterSheet = false
      this.searchFilters.createdDate = this.filter.createdDate
      this.searchFilters.gateway = this.filter.gateway
    },
    clearFilter () {
      this.showFilterSheet = false
      this.searchFilters.createdDate = []
      this.searchFilters.gateway = ''
    },
    clickOpenInvoice (invoice) {
      this.currentOpenInvoice = invoice
      this.openInvoiceDialog = true
    },
    pickDatesCancel () {
      this.filter.createdDate = this.searchFilters.createdDate
      this.datePickerOpen = false
    },
    pickDates () {
      this.datePickerOpen = false
    },
    exportCsv () {
      let params = this.filterParams
      delete params.page
      delete params.page_size
      let queryString = Object.keys(params).map(key => key + '=' + this.filterParams[key]).join('&')
      let exportDomain = process.env.VUE_APP_BASE_URL
      if (process.env.VUE_APP_ENV === 'prod') {
        exportDomain = 'https://export.yezza.io'
      }
      this.$axios.post(`/users/${this.user.id}/request_otk/`)
        .then(response => {
          const exportUrl = `${exportDomain}/transactions/export_csv/?${queryString}&key=${response.data.key}`
          if (this.$isMobile) {
            window.open(exportUrl)
          } else {
            location.href = exportUrl
          }
        }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.list-item{
  border:1px solid var(--v-primary100);
  border-radius: 0;
  border-top:4px solid var(--v-primary200);
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:var(--v-basic100);
}
</style>

<i18n>
{
  "en": {
    "search_transactions": "Search Transactions",
    "filter_transactions": "Filter Transactions",
    "clear_filters": "Clear filters",
    "no_transaction_found": "No transaction found"
  },
  "id": {
    "search_transactions": "Cari Transaksi",
    "filter_transactions": "Filter Transaksi",
    "clear_filters": "Hapus filter",
    "no_transaction_found": "Tiada transaksi ditemukan"
  }
}
</i18n>
